import axios from "axios";

import { REQUEST_ID_HEADER, VISIT_ID_HEADER } from "@shared/constants";
import { getOutgoingRequestId, getOutgoingVisitId } from "@lib/correlation";

export const createAxiosInstance = config => {
  const finalAxiosConfig = {
    ...config,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(config.headers || {}),
    },
  };

  const instance = axios.create(finalAxiosConfig);

  instance.interceptors.request.use(requestConfig => {
    const requestId = getOutgoingRequestId();

    if (requestId) {
      requestConfig.headers[REQUEST_ID_HEADER] = requestId;
    }

    const visitId = getOutgoingVisitId();

    if (visitId) {
      requestConfig.headers[VISIT_ID_HEADER] = visitId;
    }

    return requestConfig;
  });

  return instance;
};
